<template>
  <div class="modal fade" id="modal-agent">
    <div class="modal-dialog modal-dialog-l">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title">Управление представителями лагеря</h4>
        </div>
        <div class="modal-body">

          <div v-if="currentCamp != null" class="row">
            <div class="col-md-12">
              <table class="table table-bordered">
                <tbody>
                <tr>
                  <th style="width: 180px">Name</th>
                  <th>Contacts</th>
                  <th>Comments</th>
                  <th>Link</th>
                  <th></th>
                </tr>
                <tr
                  v-for="agent in currentCamp.currentAuthorizesAgents"
                  :key="agent.id">
                  <td>{{agent.name}}</td>
                  <td><b>Email</b>: {{agent.login}}<br>
                    <b>Phone</b>: {{agent.phone}}
                  </td>
                  <td>{{agent.comment}}</td>
                  <td>
                    <a v-if="agent.isActivated != true" target="_blank"
                       :href="'https://cabinet.sportlane.com/account/activate?token='+agent.activatingToken">
                      https://cabinet.sportlane.com/account/activate?token={{agent.activatingToken}}</a>
                  </td>
                  <td>
                    <span v-on:click="deleteAgent(agent)" class="badge bg-red">Удалить</span>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>
          <div v-if="currentCamp != null" class="row">
            <div class="box box-solid">
              <div class="box-body">
                <div class="box-group" id="accordion">
                  <div class="panel box box-primary">
                    <div class="box-header with-border">
                      <h4 class="box-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                          Все представители
                        </a>
                      </h4>
                    </div>
                    <div id="collapseOne" class="panel-collapse collapse">
                      <div class="box-body">
                        <table class="table table-bordered">
                          <tbody>
                          <tr>
                            <th style="width: 180px">Name</th>
                            <th>Contacts</th>
                            <th>Comments</th>
                            <th>Link</th>
                            <th></th>
                          </tr>
                          <tr
                            v-for="agent in currentCamp.authorizesAgents"
                            :key="agent.id">
                            <td>{{agent.name}}</td>
                            <td><b>Email</b>: {{agent.login}}<br>
                              <b>Phone</b>: {{agent.phone}}
                            </td>
                            <td>{{agent.comment}}</td>
                            <td>
                              <a v-if="agent.isActivated != true" target="_blank"
                                 :href="'https://cabinet.sportlane.com/account/activate?token='+agent.activatingToken">
                                https://cabinet.sportlane.com/account/activate?token={{agent.activatingToken}}</a>
                            </td>
                            <td>
                              <span v-on:click="addAgent(agent)" class="badge bg-blue">
                              Добавить
                            </span>
                            </td>
                          </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentCamp != null" class="row">
            <div class="box box-solid">
              <div class="box-body">
                <div class="box-group" id="accordions">
                  <div class="panel box box-primary">
                    <div class="box-header with-border">
                      <h4 class="box-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseOneNew">
                          Добавить нового
                        </a>
                      </h4>
                    </div>
                    <div id="collapseOneNew" class="panel-collapse collapse">
                      <div class="box-body">
                        <div class="form-group">
                          <label for="name">Email</label>
                          <input v-model="newAgent.email" type="text" class="form-control" id="email">
                        </div>
                        <div class="form-group">
                          <label for="name">Имя</label>
                          <input v-model="newAgent.name" type="text" class="form-control" id="name">
                        </div>
                        <div class="form-group">
                          <label for="name">Номер телефона</label>
                          <input v-model="newAgent.phone" type="text" class="form-control" id="phone">
                        </div>
                        <div class="form-group">
                          <label for="name">Комментарий</label>
                          <textarea style="height: 300px; width: 100%;" v-model="newAgent.comment">
                          </textarea>
                        </div>
                        <div class="form-group">
                          <button v-on:click="saveAgent" type="button" class="btn btn-primary">
                            Добавить
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{$t('button.close')}}</button>
          <button type="button" class="btn btn-primary">{{$t('button.save-changes')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {_} from 'vue-underscore';

export default {
  name: 'TrainingDescription',
  props: {
    currentCamp: Object,
    sportTypes: Array
  },
  data () {
    return {
      newAgent: {
        email: '',
        name: '',
        phone: '',
        comment: '',
        campIds: []
      }
    };
  },
  created () {

  },
  updated () {
    // eslint-disable-next-line no-undef
    $('.box').boxWidget();
  },
  methods: {
    addAgent: function (agent) {
      var self = this;

      agent.campIds.push(this.currentCamp.id);

      console.log(agent);
      // axios.put(window.rootRoute + '/api/camps/AuthorizedAgents', {agent:agent})
      axios.put(window.host + '/authorizesAgents/' + agent.id + '/campids', agent)
        .then(response => {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateCamp', self.currentCamp);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },

    deleteAgent: function (agent) {
      var self = this;

      agent.campIds = _.filter(agent.campIds, function (f) {
        return f !== self.currentCamp.id;
      });

      // axios.put(window.rootRoute + '/api/camps/AuthorizedAgents', {agent:agent})
      axios.put(window.host + '/authorizesAgents/' + agent.id + '/campids', agent)
        .then(response => {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateCamp', self.currentCamp);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    saveAgent () {
      var self = this;

      this.newAgent.campIds.push(this.currentCamp.id);

      axios.post(window.host + '/authorizesAgents', {agent: this.newAgent})
        .then(response => {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('updateCamp', self.currentCamp);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>

</style>
